// myCDkey 说明模块
export default {
  namespaced: true,
  state() {
    return {
      cad_know_explain: false,      // 用户是否看过说明
      company_know_explain: false,
      wisdomyl_know_explain: false
    }
  },
  mutations: {
    setCadKnowExplain(state, payload) {
      state.cad_know_explain = payload
    },
    setCompanyKnowExplain(state, payload) {
      state.company_know_explain = payload
    },
    setWisdomylKnowExplain(state, payload) {
      state.wisdomyl_know_explain = payload
    }
  }
}
